import React from 'react';
import initializeFirebase from './initializeFirebase';

const DefaultLoading = () => <div>loading</div>;

export class AnonymousSignInGate extends React.PureComponent {
  state = {
    authorized: false,
  };

  _unregisterAuthStateChangeListener = null;
  componentDidMount() {
    let { firebase } = this.props;

    this._unregisterAuthStateChangeListener = firebase
      .auth()
      .onAuthStateChanged((user) => {
        if (user) this.setState({ authorized: true });
        else firebase.auth().signInAnonymously();
      });
  }

  render() {
    const { children, Loading = DefaultLoading } = this.props;
    const { authorized } = this.state;
    return authorized ? children : <Loading />;
  }
}
